import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

/**
 * Pinia 存储管理模块 (PC端适配版)
 * 提供状态管理和持久化功能
 */

// 创建 pinia 实例
const pinia = createPinia()

// 使用持久化插件
pinia.use(piniaPluginPersistedstate)

// 导出pinia实例
export default pinia

// 导出所有store
export * from './stores' 